import React from "react";
import "./Advantages.css";
import { Gauge, Tv, Tv2, Receipt, Film, Wifi } from "lucide-react";

function Advantages() {
    return (
        <section className="advantages-section">
            <h2 className="section-title">Ritu Broad Band Advantage</h2>

            <div className="advantages-grid">
                <div className="advantage-card">
                    <div className="advantage-icon">
                        <Gauge size={28} />
                    </div>
                    <h3>High Speed Internet</h3>
                    <p>Up to 200 Mbps</p>
                </div>

                <div className="advantage-card">
                    <div className="advantage-icon">
                        <Tv size={28} />
                    </div>
                    <h3>29 OTT Platforms</h3>
                    <p>Including Netflix</p>
                </div>

                <div className="advantage-card">
                    <div className="advantage-icon">
                        <Tv2 size={28} />
                    </div>
                    <h3>300+ Live Channels</h3>
                    <p>FTA TV Channels</p>
                </div>

                <div className="advantage-card">
                    <div className="advantage-icon">
                        <Receipt size={28} />
                    </div>
                    <h3>Single Bill</h3>
                    <p>For TV & Internet</p>
                </div>

                <div className="advantage-card">
                    <div className="advantage-icon">
                        <Film size={28} />
                    </div>
                    <h3>12000+ Movies</h3>
                    <p>On-Demand Content</p>
                </div>

                <div className="advantage-card">
                    <div className="advantage-icon">
                        <Wifi size={28} />
                    </div>
                    <h3>Free WiFi ONT</h3>
                    <p>Conditions Apply</p>
                </div>
            </div>
        </section>
    );
}

export default Advantages;

